module.exports = __webpack_public_path__ + "img/information-circle.55c74c49.svg";